/**
 * Função utilitária para gerar e baixar a cotação como imagem PNG
 * Usa apenas Canvas API nativa do navegador
 */

export const downloadCotacaoAsImage = async (element, dadosCotacao, planoCarro, cotacaoVeiculo) => {
  if (!element) {
    console.error('Elemento não encontrado');
    return;
  }

  try {
    // Criar canvas com dimensões do elemento
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    // Definir dimensões fixas para a imagem (sem responsividade)
    const width = 600;
    const height = 1100; // Altura fixa proporcional ao conteúdo
    
    // Definir dimensões do canvas (2x para melhor qualidade)
    const scale = 2;
    canvas.width = width * scale;
    canvas.height = height * scale;
    ctx.scale(scale, scale);

    // Preencher fundo preto
    ctx.fillStyle = '#000000';
    ctx.fillRect(0, 0, width, height);

    // Configurar estilos de texto
    ctx.textBaseline = 'top';
    
    // Função auxiliar para desenhar texto
    const drawText = (text, x, y, fontSize, color = '#FFFFFF', fontWeight = 'normal', align = 'left') => {
      ctx.fillStyle = color;
      ctx.font = `${fontWeight} ${fontSize}px Arial, sans-serif`;
      ctx.textAlign = align;
      ctx.fillText(text, x, y);
    };

    // Função para desenhar retângulo com borda
    const drawRect = (x, y, w, h, fillColor, borderColor = null) => {
      ctx.fillStyle = fillColor;
      ctx.fillRect(x, y, w, h);
      if (borderColor) {
        ctx.strokeStyle = borderColor;
        ctx.lineWidth = 2;
        ctx.strokeRect(x, y, w, h);
      }
    };

    // Função para carregar e desenhar imagem
    const loadAndDrawImage = (src, x, y, maxWidth, maxHeight) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        
        img.onload = () => {
          // Calcular dimensões mantendo proporção
          let imgWidth = 300;
          let imgHeight = 170;

          const aspectRatio = imgWidth / imgHeight;
          
          // Centralizar imagem
          const drawX = x + (maxWidth - imgWidth) / 2;
          const drawY = y + (maxHeight - imgHeight) / 2;
          
          ctx.drawImage(img, drawX, drawY, imgWidth, imgHeight);
          resolve({ width: imgWidth, height: imgHeight });
        };
        
        img.onerror = () => {
          console.error('Erro ao carregar logo');
          resolve({ width: 0, height: 0 }); // Continua sem a logo
        };
        
        img.src = src;
      });
    };

    // Desenhar borda verde do modal
    ctx.strokeStyle = '#00FF00';
    ctx.lineWidth = 2;
    ctx.strokeRect(0, 0, width, height);

    let currentY = 30;

    // Desenhar Header com Logo no centro e informações à direita
    const logoStartY = currentY;
    
    // Buscar a imagem da logo do DOM
    const logoImg = element.querySelector('img[alt="Logo"]');
    if (logoImg && logoImg.src) {
      // Logo grande no centro - 380x95
      const logoMaxWidth = 380;
      const logoMaxHeight = 95;
      const logoX = (width - logoMaxWidth) / 2; // Centralizar
      await loadAndDrawImage(logoImg.src, logoX, currentY, logoMaxWidth, logoMaxHeight);
    }

    // Informações da cotação (à direita, centralizadas verticalmente)
    const infoX = width - 180;
    const infoStartY = logoStartY + 15;
    let infoY = infoStartY;
    
    drawText(`COTAÇÃO: ${dadosCotacao.cotacao}`, infoX, infoY, 13, '#FFFFFF', 'bold');
    infoY += 23;
    drawText(`DATA: ${dadosCotacao.data}`, infoX, infoY, 13, '#FFFFFF', 'bold');
    infoY += 23;
    drawText(`VALIDADE: ${dadosCotacao.validade}`, infoX, infoY, 13, '#FFFFFF', 'bold');
    
    // Avançar currentY após o header
    currentY += 110;

    // Linha separadora
    ctx.strokeStyle = '#00FF00';
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(10, currentY);
    ctx.lineTo(width - 10, currentY);
    ctx.stroke();
    currentY += 20;

    // Informações do veículo
    // dadosCotacao.veiculo fonte maiuscula.
    const veiculoUpper = dadosCotacao.veiculo.toUpperCase();

    drawRect(10, currentY, width - 20, 100, '#1a1a1a');
    currentY += 15;
    drawText('OLÁ, ESTA É UMA COTAÇÃO PARA O SEU VEÍCULO', 20, currentY, 12);
    currentY += 20;
    drawText(veiculoUpper, 20, currentY, 12, '#FFFFFF', 'bold');
    currentY += 20;
    drawText(`PLACA: ${dadosCotacao.placa}`, 20, currentY, 12);
    currentY += 20;
    drawText(`AVALIADO EM ${dadosCotacao.valorAvaliado}`, 20, currentY, 12);
    currentY += 35;

    // Título BENEFÍCIOS
    drawRect(10, currentY, width - 20, 40, '#00FF00');
    drawText('BENEFÍCIOS', width / 2, currentY + 12, 16, '#000000', 'bold', 'center');
    currentY += 50;

    // Tabela de benefícios
    const tableX = 10;
    const tableWidth = width - 20;
    const col1Width = tableWidth * 0.5;
    const col2Width = tableWidth * 0.25;
    const col3Width = tableWidth * 0.25;
    const rowHeight = 35;

    planoCarro.forEach((item, index) => {
      const rowY = currentY + (index * rowHeight);
      
      // Fundo da linha
      drawRect(tableX, rowY, tableWidth, rowHeight, '#1a1a1a');
      
      // Bordas
      ctx.strokeStyle = '#333333';
      ctx.lineWidth = 1;
      ctx.strokeRect(tableX, rowY, tableWidth, rowHeight);
      
      // Textos
      ctx.fillStyle = '#FFFFFF';
      ctx.font = '12px Arial';
      ctx.textAlign = 'left';
      
      // Coluna 1 - Item (com quebra de linha se necessário)
      const words = item.item.split(' ');
      let line = '';
      let lineY = rowY + 10;
      words.forEach(word => {
        const testLine = line + word + ' ';
        const metrics = ctx.measureText(testLine);
        if (metrics.width > col1Width - 20 && line !== '') {
          ctx.fillText(line, tableX + 10, lineY);
          line = word + ' ';
          lineY += 12;
        } else {
          line = testLine;
        }
      });
      ctx.fillText(line, tableX + 10, lineY);
      
      // Coluna 2 - Valor
      ctx.textAlign = 'center';
      ctx.fillText(item.valor, tableX + col1Width + (col2Width / 2), rowY + 18);
      
      // Coluna 3 - Percentual
      ctx.fillText(item.percentual, tableX + col1Width + col2Width + (col3Width / 2), rowY + 18);
    });

    currentY += planoCarro.length * rowHeight + 20;

    // Título VALORES
    drawRect(10, currentY, width - 20, 40, '#00FF00');
    drawText('VALORES', width / 2, currentY + 12, 16, '#000000', 'bold', 'center');
    currentY += 50;

    // Tabela de valores
    cotacaoVeiculo.forEach((item, index) => {
      const rowY = currentY + (index * 30);
      drawRect(tableX, rowY, tableWidth, 30, '#1a1a1a');
      ctx.strokeStyle = '#333333';
      ctx.lineWidth = 1;
      ctx.strokeRect(tableX, rowY, tableWidth, 30);
      
      ctx.fillStyle = '#FFFFFF';
      ctx.font = '13px Arial';
      ctx.textAlign = 'left';
      ctx.fillText(item.item, tableX + 10, rowY + 12);
    });

    currentY += cotacaoVeiculo.length * 30 + 20;

    // Título CONSULTOR
    drawRect(10, currentY, width - 20, 40, '#00FF00');
    drawText('CONSULTOR', width / 2, currentY + 12, 16, '#000000', 'bold', 'center');
    currentY += 50;

    // Informações do consultor (nome à esquerda, telefone abaixo)
    drawRect(10, currentY, width - 20, 60, '#1a1a1a');

    const consultor = dadosCotacao.consultor.nome;
    // consultor fonte maiuscula.
    const consultorUpper = consultor.toUpperCase();
    
    // Nome à esquerda
    const nomeY = currentY + 12;
    drawText(`NOME: ${consultorUpper}`, 20, nomeY, 13, '#FFFFFF', 'bold');
    
    // Telefone abaixo do nome (também à esquerda)
    const telefoneY = nomeY + 25;
    drawText(`TELEFONE: ${dadosCotacao.consultor.telefone}`, 20, telefoneY, 13, '#FFFFFF', 'bold');
    
    currentY += 60;

    // Converter canvas para blob e fazer download
    canvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `cotacao_${dadosCotacao.cotacao}_${dadosCotacao.placa}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }, 'image/png', 1.0);

  } catch (error) {
    console.error('Erro ao gerar imagem:', error);
    alert('Erro ao gerar imagem. Tente novamente.');
  }
};
